import FooterIcon from '@mui/icons-material/VideoLabel';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {
  FooterSwatch,
  SnapshotMenuButton,
  ToggleButton,
  ToggleButtonGroup,
} from './snapshot.styles.jsx';
import {FOOTER_STYLES} from '@explorer/util/snapshot';

const FooterStyleMenu = props => {
  const {t} = useTranslation();

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      props.onChange(newValue);
    }
  };
  return (
    <SnapshotMenuButton
      label={<FooterIcon />}
      tooltipTitle={t('snapshot.tooltipFooterMenu')}
      data-qe="snapshot-footer-style-button"
    >
      <ToggleButtonGroup value={props.value} onChange={handleChange}>
        <ToggleButton
          value={FOOTER_STYLES.GRADIENT}
          tooltipTitle={t('snapshot.tooltipFooterGradient')}
        >
          <FooterSwatch gradient />
        </ToggleButton>

        <ToggleButton
          value={FOOTER_STYLES.DARK}
          tooltipTitle={t('snapshot.tooltipFooterDark')}
        >
          <FooterSwatch bgcolor="black" />
        </ToggleButton>

        <ToggleButton
          value={FOOTER_STYLES.LIGHT}
          tooltipTitle={t('snapshot.tooltipFooterLight')}
        >
          <FooterSwatch bgcolor="white" />
        </ToggleButton>
        <ToggleButton
          value={FOOTER_STYLES.NONE}
          tooltipTitle={t('snapshot.tooltipFooterNone')}
        >
          <FooterSwatch transparent />
        </ToggleButton>
      </ToggleButtonGroup>
    </SnapshotMenuButton>
  );
};

FooterStyleMenu.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FooterStyleMenu;
